const cards = [
  {
    title: '咒术回战',
    desc: '咒术高专的少年们以诅咒对抗诅咒，宿命之战震撼人心。虎杖悠仁吞下两面宿傩的手指后，踏上了成为咒术师的危险之路。',
    tag: '热血·战斗',
    image: 'https://readdy.ai/api/search-image?query=Dark%20fantasy%20anime%20scene%20with%20intense%20combat%20poses%2C%20cursed%20energy%20visual%20effects%20in%20deep%20warm%20orange%20and%20crimson%20tones%2C%20dynamic%20action%20composition%2C%20Japanese%20jujutsu%20sorcerer%20aesthetic%2C%20clean%20dramatic%20lighting&width=600&height=400&seq=51anime-card-01&orientation=landscape',
  },
  {
    title: '葬送的芙莉莲',
    desc: '勇者队伍击败魔王之后，精灵魔法使芙莉莲踏上了理解人类情感的旅程。十年冒险结束，但她的故事才刚刚开始。',
    tag: '奇幻·治愈',
    image: 'https://readdy.ai/api/search-image?query=Ethereal%20fantasy%20anime%20scene%20with%20elf%20mage%20walking%20through%20flowering%20meadow%2C%20soft%20golden%20sunlight%20filtering%20through%20trees%2C%20nostalgic%20melancholic%20atmosphere%2C%20cream%20and%20warm%20amber%20palette%2C%20gentle%20storytelling%20aesthetic&width=600&height=400&seq=51anime-card-02&orientation=landscape',
  },
  {
    title: '鬼灭之刃',
    desc: '大正时代的少年灶门炭治郎，为拯救变成鬼的妹妹祢豆子，加入鬼杀队与恶鬼展开殊死搏斗。水之呼吸，生生不息。',
    tag: '热血·冒险',
    image: 'https://readdy.ai/api/search-image?query=Demon%20slayer%20anime%20scene%20with%20water%20breathing%20sword%20technique%20visual%20effects%2C%20flowing%20blue%20and%20coral%20energy%20waves%2C%20traditional%20Japanese%20aesthetic%2C%20dramatic%20moonlit%20atmosphere%2C%20dynamic%20action%20composition&width=600&height=400&seq=51anime-card-03&orientation=landscape',
  },
  {
    title: '斗破苍穹',
    desc: '天才少年萧炎从云端跌落谷底，凭借药老指导和坚韧意志，一步步重回巅峰。三十年河东，三十年河西，莫欺少年穷！',
    tag: '国漫·玄幻',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20fantasy%20donghua%20scene%20with%20martial%20artist%20in%20flowing%20robes%2C%20mystical%20fire%20energy%20surrounding%20figure%2C%20ancient%20Chinese%20architecture%20background%2C%20dramatic%20golden%20and%20coral%20lighting%2C%20epic%20cultivation%20atmosphere&width=600&height=400&seq=51anime-card-04&orientation=landscape',
  },
  {
    title: '我推的孩子',
    desc: '偶像与演艺圈的残酷真相，前世今生的复仇与守护。天才童星星野爱的孩子们，在娱乐圈中追寻真相与梦想。',
    tag: '悬疑·剧情',
    image: 'https://readdy.ai/api/search-image?query=Idol%20anime%20scene%20with%20sparkling%20stage%20lights%20and%20performer%20silhouette%2C%20dramatic%20contrast%20between%20bright%20spotlights%20and%20deep%20shadows%2C%20showbiz%20atmosphere%2C%20warm%20amber%20and%20cream%20tones%2C%20theatrical%20composition&width=600&height=400&seq=51anime-card-05&orientation=landscape',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">精选推荐</h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            编辑团队精心甄选，每一部都值得从头追到尾
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-5 gap-4 md:gap-5">
          {cards.map((item, idx) => {
            const isFeature = idx === 0;
            const colSpan = isFeature ? 'lg:col-span-3' : 'lg:col-span-2';
            const rowSpan = isFeature ? 'lg:row-span-2' : '';

            return (
              <a
                key={item.title}
                href="#cards"
                className={`${colSpan} ${rowSpan} group block bg-background-100 rounded-lg overflow-hidden border border-background-200/60 hover:border-primary-200 transition-colors cursor-pointer`}
              >
                <div className={`${isFeature ? 'aspect-[3/2]' : 'aspect-[3/2]'} overflow-hidden bg-background-200`}>
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                </div>
                <div className="p-4 md:p-5">
                  <span className="inline-block px-2 py-0.5 bg-primary-100 text-primary-700 text-xs rounded-full font-medium mb-2">{item.tag}</span>
                  <h3 className={`${isFeature ? 'text-lg' : 'text-base'} font-semibold text-foreground-900 mb-1 group-hover:text-primary-500 transition-colors`}>{item.title}</h3>
                  <p className="text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
                </div>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}